import { connect } from 'react-redux';
import CRUDAction from '../../../actions/competition';
import CompetitionsEditForm from '../CompetitionsEditForm'
import LoadingContainer from '../../LoadingContainer';

export default connect(
  ({ competition: { loadingItem } }) => ({
    loading: loadingItem,
    childrenComponent: CompetitionsEditForm,
    childrenProps: {
      title: 'Edit Competition',
      isNew: false
    }
  }),
  dispatch => ({
    init: ({ params: { id }}) => dispatch(CRUDAction.fetch(id))
  })
)(LoadingContainer);



// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionsEdit/index.js